//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
export default {
  name: 'npc-list',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    window.seedAction({
      bid: 'b_movie_1kh46axa_mv',
      evt: 'view'
    });
  },
  methods: {
    gotoCastDetail: function gotoCastDetail(item) {
      if (!item) return;
      this.$emit('item-click');
      Drip.redirect("/myshow/#/actor-detail?id=".concat(item.id));
      window.seedAction({
        bid: 'b_movie_1kh46axa_mc'
      });
    }
  }
};